import { render } from "./EditRework.vue?vue&type=template&id=2b57cbe6"
import script from "./EditRework.vue?vue&type=script&lang=js"
export * from "./EditRework.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__